import React from 'react';
import { useHistory } from 'react-router';
import { NavLink } from 'react-router-dom';
import { updateAnonymous } from 'Shared/api/onboardingState';

import danAvatar from 'Shared/images/dan.png';
import dialpadLogo from 'Shared/images/gray-dialpad-logo.svg';

import landingImage from './landing-image.svg';

import './LandingPageBody.scss';

function LandingPageBody() {
  const history = useHistory();

  updateAnonymous();

  const handleFindMyTeamClick = () => {
    (window as any).analytics.track('Clicked in Landing Page', { button: 'Find My Team' });
    history.push('/user/signup?find_my_team=true');
  };

  const handleCreateTeamClick = () => {
    (window as any).analytics.track('Clicked in Landing Page', { button: 'Create New Team' });
    history.push('/onboarding/wizard');
  };

  return (
    <div className="landing-page-body d-flex">
      <div className="landing-page-body-right position-relative mr-4 d-flex flex-column">
        <div className="landing-page-body-right-title mb-3">Try Perform with your team</div>
        <div className="landing-page-body-right-subtitle mb-4">Create a new space for you and your team for free!</div>
        <div className="d-flex justify-content-between h-100">
          <button
            type="button"
            onClick={handleCreateTeamClick}
            className="landing-page-body-create-team btn btn-primary align-self-baseline flex-shrink-0"
          >
            + Create a New Team
          </button>
          <img src={landingImage} alt={landingImage} className="landing-page-body-right-image mt-auto ml-auto" />
        </div>
      </div>
      <div className="landing-page-body-left d-flex flex-column w-100">
        <div className="landing-page-body-container py-2 px-4 mb-4">
          <div className="landing-page-body-container-title mb-3">Is your team already on Perform?</div>
          <div className="landing-page-body-container-description mb-3">Find your team to join them now!</div>
          <button
            type="button"
            className="btn find-team-button btn-outline-primary align-self-baseline mb-3"
            onClick={handleFindMyTeamClick}
          >
            Find my Team
          </button>
          <div className="mb-4">
            Already have an account?&nbsp;
            <NavLink to="/user/login">Sign in</NavLink>
          </div>
        </div>

        <div className="landing-page-body-container d-flex flex-column py-2 px-4 w-100 h-100">
          <div className="d-flex mb-2 align-items-center">
            <div className="landing-page-body-avatar bg-white circle mr-2">
              <img className="circle" src={danAvatar} alt={danAvatar} width={55} />
            </div>
            <div className="d-flex flex-column">
              <div className="landing-page-body-name">Dan O’Connell</div>
              <div className="landing-page-body-position">
                CSO/CRO at <img src={dialpadLogo} alt={dialpadLogo} className="ml-1" />
              </div>
            </div>
          </div>

          <div className="landing-page-body-speech">
            “With the shift towards hybrid work, PI Perform went from being a helpful tool to a critical piece of
            infrastructure. We use it to execute daily tasks & stay in sync with how employees are feeling day-to-day.”
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingPageBody;
